<template>
  <div :class="pageSetInfo.listStyleSet.cellContainerOpenMode == 1?'lmf_tree':'' + 'outLineTreeBox'">
    <div role="tree" class="el-tree LineTree" :style="pageSetInfo.listStyleSet.listPageTreeOutermostBoxStyleSet?pageSetInfo.listStyleSet.listPageTreeOutermostBoxStyleSet.styleSetCode:''" kwName="listPageTreeOutermostBoxStyleSet">
      <div role="treeitem" class="el-tree-node is-expanded is-focusable" v-for="(item,index) in treeData" :key="index" :style="pageSetInfo.listStyleSet.listPageTreeListBoxStyleSet?pageSetInfo.listStyleSet.listPageTreeListBoxStyleSet.styleSetCode:''" kwName="listPageTreeListBoxStyleSet">
        <lmf_tree_view :pageSetInfo="pageSetInfo" :oneTreeData="item" :treeIndex="treeIndex" :prevIndex="prevIndex" :nowIndex="(index+1)+''" ></lmf_tree_view>
      </div>
    </div>
    <div class="cellRightBox" :style="pageSetInfo.listStyleSet.listPageCellWithinRightBoxStyleSet?pageSetInfo.listStyleSet.listPageCellWithinRightBoxStyleSet.styleSetCode:''" kwName="listPageCellWithinRightBoxStyleSet" v-if="pageSetInfo.listStyleSet.cellContainerOpenMode == 1">
	    <kw_list v-if="(rightPageInfo.type==1 && rightPageInfo.ifLoad)" ref="kw_list" id="kw_list" :initPageObj="rightPageInfo" :isLimitButton="isLimitButton"></kw_list>
      <kw_look v-else-if="(rightPageInfo.type==11 && rightPageInfo.ifLoad)" ref="kw_look" :pageInfo="rightPageInfo" @goBack="cancelToFirst" :isLimitButton="isLimitButton"></kw_look>
    </div>
  </div>
</template>

<script>
// 树形组件
import lmf_tree_view from '@/components/form/lmf_tree_view.vue';

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'lmf_tree',
  props: {
    treeIndex:{
      type:Number,
      default: 1
    },
    //如果是 提供了页面等信息则 在树组件中去获取数据
    initParam:{
      type: Object,
      default: null
    },
    //传入的数据为列表数据 需要进行数据处理
    initListData:{
      type: Array,
      default: null
    },
    prevIndex:{
      type: String,
      default: ""
    },
    nowIndex:{
      type: String,
      default: ""
    },
    pageSetInfo:{
      type: Object,
      default: null
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      treeData:{
        type: Array,
        default: []
      },
      rightPageInfo:{
        type : Object,
        default:{
          ifLoad:false
        }
      }
    };
  },
  created() {
    if (this.initListData) {
      var outLineArr = pageUtils.buildTree(this.initListData);
      console.log("outLineArr=======================",outLineArr);
      this.treeData = outLineArr;
    }
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    lmf_tree_view,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*课程树*/
.el-tree{position: relative;cursor: default;background: #fff;color: #606266;}
.el-tree-node__expand-icon{cursor: pointer;color: #c0c4cc;font-size: 12px;-webkit-transform: rotate(0);transform: rotate(0);-webkit-transition: -webkit-transform .3s ease-in-out;transition: -webkit-transform .3s ease-in-out;transition: transform .3s ease-in-out;transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;}
.el-icon-caret-right:before{content: '';display: inline-block;width: 0;height: 0;overflow: hidden;border: 7px solid transparent;border-left-color: #9096ac;border-right-width: 0;margin: 5px 2.5px;}

/* .outLineTreeBox{margin-left: 0.5rem} */
.outLineTreeBox .el-tree{overflow: hidden;padding-bottom: 5px;padding-left: 20px}
.outLineTreeBox .el-tree-node__expand-icon{color: #9096ac;font-size: 1.2rem;padding: 6px;font-family: element-icons!important;speak: none;font-style: normal;font-weight: 400;font-variant: normal;text-transform: none;line-height: 1;vertical-align: baseline;display: inline-block;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;}
.outLineTreeBox .el-tree-node__content{padding: .5rem;margin: .4rem;margin-bottom: 0;background: #fff;cursor: auto;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;height: 26px;cursor: pointer;}
.outLineTree{width: 100%;position: relative;overflow: hidden;}
.outLineTree span{padding: 0 .2rem;vertical-align: middle;}
.outLineTree .TreeType{display: inline-block;}
.outLineTree .TreeType:after{content: '：';}
.roleGroup .roleGroup .roleGroup .TreeType:before{content: '';display: inline-block;width: 1.2rem; height: 1rem;margin-right: .5rem;background: url() no-repeat center;background-size: 100% 100%;vertical-align: -1px;}
.outLineTree .TreeName{font-weight: bold;}
.roleGroup .roleGroup .TreeName{font-weight: normal;}
/*.outLineTree .TreeDate{}*/
.outLineTree .TreeDate:before{content: '-';}
.outLineTree .TreeBuy{float: right;min-width: 6em;padding: .2rem 0;text-align: center;}
.outLineTree .TreeBtn{float: right;min-width: 6em;border-radius: 3em;color: #fff;padding: .2rem 0;text-align: center;margin-right: .5rem;}
.TreeBtn{background: #c1c1c1;}/*默认*/
.EnterStudio{background: #ff494b;cursor: pointer;}/*进入直播*/
.NotTime{background: #ff9c00;cursor: pointer;}/*未开始*/
.LookStudio{background: #6d5bff;cursor: pointer;}/*回看*/
.download{background: transparent;cursor: pointer;}/*点击下载*/
span.download image{display: inline-block;width: 1.5rem;height: 1.5rem;}/*点击下载*/
/*.Ununlocked{}不可做*/
/*.Rolls{}未完成*/
.CheckRolls{background: #15ba6b;cursor: pointer;}/*查看*/
.CheckRolls:before{content: '';background: url() no-repeat center;background-size: 100% 100%;display: inline-block;width: 1.15rem;height: 1.15rem;margin-right: .2rem;vertical-align: -3px;}/*回看*/

.el-tree-node__expand-icon.is-leaf{color: transparent;cursor: default;visibility: hidden;}
.el-tree-node__expand-icon.expanded{-webkit-transform: rotate(90deg);transform: rotate(90deg);}

.roleGroup .roleGroup .roleGroup .TreeType:before{background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDREI2QTA5QTg2MTExRTk5RjlBRUE4NUIxQUUxRTdGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDREI2QTBBQTg2MTExRTk5RjlBRUE4NUIxQUUxRTdGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MENEQjZBMDdBODYxMTFFOTlGOUFFQTg1QjFBRTFFN0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MENEQjZBMDhBODYxMTFFOTlGOUFFQTg1QjFBRTFFN0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4+GbfMAAAA60lEQVR42mL8//8/AzUB4/9WpSogXQjEIljkG4C4Ea8JVXcxDIQ58QgQM0HZf4FYDIjVgfgAEHsA8U9SDDwIxA5YlCcB8Vwg/gfEC4EYV/gwAvEXIN4JM/A4EFvhUKwCUgjESsSEIROSDbjAHSBWBmI+AngGSDELCRH4GW8Ytil/ImSgLBD7QsMPF2AGGnQHaCgoSNgJGWgGxFOJcPlJaBj/I2TgdiDWIOhCBoaPyPGBz8BvQHyToPsQ6ZAJOZapBkawgV+pYNYb5MIBlDQmE8iC+ABIfyAQy4MMbAUy0oFYmEIXgoq3dQABBgAZ1j3BGTimMAAAAABJRU5ErkJggg==);}
.CheckRolls:before{background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjRBOEJBNTFFQTg2MTExRTk4OUY3QzcyNkZFNDA5NTVGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjRBOEJBNTFGQTg2MTExRTk4OUY3QzcyNkZFNDA5NTVGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NEE4QkE1MUNBODYxMTFFOTg5RjdDNzI2RkU0MDk1NUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NEE4QkE1MURBODYxMTFFOTg5RjdDNzI2RkU0MDk1NUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5xHReMAAABdUlEQVR42pTUTygEURzA8aEc5ODgz8FJykpOS2rlb2qT5OYgV3FyUOvgQi6kJBcn5bQHB+2BXIbDlovUOqxsSflzcEOK2vJnG99ffsM0vRnm1WfnzXvv95s3O78Zy3Ecy2AQB3jGOz7xhCOMmmLK5MfTWpBGJy5gI48SWjGMDlxq/+4n0pd5CtdoD9ipiCHnfLded9ydrEBTSLDJtiZr9N5aDm/otqK1czSgVjLHNXN/hN1U6bFSY8flxMZthCTzGhzX82PcSOcFK/9MMqtJ8qjRsWkpEel8yNY8i1NYNiSZ0yS2b7xHakw6JYx5JtY0IOMZW9exHcMFutxERSz4Jpc0cENrKyiJmHBv7QQFw4JF57elQ/63PTxKJ6mL6wyLVrH7xwOQlnJP7nEVsbLFqSayyrVCE2jGVsTKlpc66X9pBzR7FvUhu6jGJhJhn5EYsvr+HGIfBcjO2zCEERTRh7Ogz4hrUqtXPmwPenzVpztjivkSYADvA07CGrMU1AAAAABJRU5ErkJggg==);}


.treeBox{background: #ffffff}
.treeListBox{border-bottom: 1px solid #F3F3F3}
.treeList{padding: 20px 25px}
.treeTitle{font-size: 14px;color: #484848;font-weight: bold;padding: 8px 0}
.treeTitle text{background: #EDEDEF;display: inline-block;font-weight: normal;font-size: 12px;border-radius: 18px;width: 18px;height: 18px;text-align: center;line-height: 18px;margin-right: 5px}
.treeListItem{font-size: 14px;color: #6F6F6F;display: flex;justify-content: space-between;padding: 5px 0;}


.lmf_tree{display: flex;justify-content: space-between;flex-wrap:wrap}
.cellRightBox{background: #fff;min-height: 700px;width: 76%;margin-top: 20px}
</style>
